import React from 'react';
import { Modal, message, Button, Popconfirm, Icon, Tooltip } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

class MorePmHandover extends React.Component {
    state = {
        visible: false,
        loading: false,
        list: [],
    }

    show = (list) => {
        this.setState({
            visible: true,
            list,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    render() {
        const { visible, loading, list } = this.state;
        return (
            <div>
                <Modal
                    title="进行中的PM交接记录"
                    visible={visible}
                    onCancel={this.hide}
                    className="create-modal"
                    wrapClassName="vertical-center-modal"
                    maskClosable={false}
                    width="800px"
                    loading={loading}
                    footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
                >
                    {
                        list.length ?
                            <div>
                                {
                                    list.map((el, index) => 
                                        <div className='backlogli'>
                                            <Tooltip title={el.remark} overlayStyle={{ maxWidth: 350 }}>
                                                <div 
                                                    className='left' 
                                                    style={{color: el.red ? 'red' : '#5750b7', whiteSpace: 'normal'}} 
                                                    onClick={() => this.props.clickNotice(null, el, index)}
                                                >
                                                    {el.remark}
                                                </div>    
                                            </Tooltip>
                                            <div className='right'>
                                                <br />
                                                <span style={{color:'#cccccc'}}>{moment(el.createTime).format('YYYY-MM-DD')}</span>
                                            </div>
                                        </div>
                                    )
                                }
                                <div className='data_null'>
                                    {
                                        list.length == 0 && <span><i className='anticon anticon-frown-o'></i>暂无数据</span>
                                    }
                                </div>
                            </div>
                        :
                            null
                    }
                </Modal>
            </div>
        );
    }
}

export default MorePmHandover;


// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/MorePmHandover.js